import { useEffect } from 'react';
import { useClerk } from '@clerk/clerk-react';
import { useLocation, useNavigate } from 'react-router-dom';
import mixpanel from 'mixpanel-browser';
import qs from 'qs';

import { Loader } from '@/components/ui/loader';

/**
 * Signs the user out via Clerk, fires off analytics, then sends them back to
 * `/login`. Preserves any `unify_chat_session_*` localStorage entries so a
 * returning user keeps their AI chat history.
 */
export function Logout() {
	const { signOut } = useClerk();
	const location = useLocation();
	const navigate = useNavigate();
	const { shop } = qs.parse(location.search.substring(1));

	useEffect(() => {
		if (!signOut) return;
		mixpanel.track('Logout', { shop });
		mixpanel.reset();
		// Wait for the sign-out to finish before landing on /login — navigating early
		// leaves the session on the Clerk client, where the login form's signIn.create
		// trips single-session mode's `session_exists` error (NEA-5953).
		(async () => {
			try {
				await signOut();
			} catch {
				// Best-effort — an already-removed session or a network blip shouldn't trap
				// the user on the logout screen.
			}
			localStorage.removeItem('nearst.v1.token');
			navigate('/login');
		})();
	}, [signOut, shop, navigate]);

	return <Loader label="Signing you out…" />;
}
